import { https } from "../http";
import store from "../store";
import {
  setAddBillingInvoicesLoading,
  setAllBillinginvoices,
  setAllBillinginvoicesConsumers,
  setAllBillingPaidinvoices,
  setAllBillingRecurringinvoices,
  setAllCashChequeInvoices,
  setLoading,
} from "../store/reducers/billinginvoice";
import { showError } from "../utils/index";

// POST  // CREATE BILLING INVOICES
const createBillingInvoices = async (data, callback) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// UPDATE BILLING STATUS


const UpdateBillingInvoicesStatus = async (data, callback,showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/update-status-paid", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      getAllBillingInvoices(showLoading);
      // callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// Resend Billing Invoice Email

const resendInvoiceEmail = async (data, callback,showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/resend-invoice-email", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      getAllBillingInvoices(showLoading);
      // callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};



//get BILLING INVOICES

const getAllBillingInvoices = async (payload, showLoading = true) => {
  const { customerId, page, selectedMonth, query } = payload || {};
  let response;

  if (showLoading) store.dispatch(setLoading(true));

  // Construct URL based on payload parameters
  let url = `billingInvoices/${page ? page : "all"}/${selectedMonth || 1}`;
  if (customerId) {
    url += `?customerId=${customerId}`;
  }
  if (query) {
    url += `?query=${encodeURIComponent(query)}`;
  }
  try {
    response = await https().get(url);
    if (response?.status === 200) {
      store.dispatch(setAllBillinginvoices(response.data));
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  } finally {
    if (showLoading) store.dispatch(setLoading(false));
  }
};

// const getAllBillingInvoices = async (payload, showLoading = true) => {
//   console.log("payload", payload);

//   const customerId = payload?.customerId;
//   try {
//     if (showLoading) store.dispatch(setLoading(true));

//     if (customerId) {
//       let response = await https().get(
//         `billingInvoices/${payload && payload.page ? `${payload.page}` : "all"}/${
//           payload?.selectedMonth || 1
//         }?customerId=${payload?.customerId}`
//       );
//     } else {
//       let response = await https().get(
//         `billingInvoices/${payload && payload.page ? `${payload.page}` : "all"}/${
//           payload?.selectedMonth || 1
//         }`
//       );
//     }

//     if (response?.status === 200) {
//       store.dispatch(setAllBillinginvoices(response?.data));
//       store.dispatch(setLoading(false));
//       return response;
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status);
//     return false;
//   }
// };

// EDIT BILLING INVOICE

const EditBillingInvoice = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().put(`/billingInvoices/${data?.id}`, data);

    if (response?.status === 200) {
    let payload = {
      page: 1,
    };
      getAllBillingRecurringInvoices(payload);
      getAllBillingInvoices(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE BILLING INVOICES

const removeBillingInvoice = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));

    // console.log('data',data);

    let response = await https().delete(`/billingInvoices/${data?.id}`);

    if (response?.status === 200) {
      await getAllBillingInvoices((showLoading = true));
      await getAllBillingRecurringInvoices((showLoading = true));
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// POST CREATE BILLING COSUMER
const createBillingconsumer = async (data, callback) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingconsumer", data);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};




//get BILLING CONSUMER

// const getAllBillingConsumers = async (payload, showLoading = true) => {
//   try {
//     const { page, query } = payload || {};
//     if (showLoading) store.dispatch(setLoading(true));
//     let response = await https().get(
//       `billingconsumer/${page ? page : "all"}${
//         query ? `?query=${encodeURIComponent(query)}` : ""
//       }`
//     );
//     store.dispatch(setAllBillinginvoicesConsumers(response?.data));
//     if (response?.status === 200) {
//       store.dispatch(setAllBillinginvoicesConsumers(response?.data));
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status);
//     return false;
//   }
// };

const getAllBillingConsumers = async (payload, showLoading = true) => {
  try {
    const { page, query, status } = payload || {}; 
    if (showLoading) store.dispatch(setLoading(true));
    
    let url = `billingconsumer/${page ? page : "all"}`;
    
    // Check if there's a query or status to append to the URL
    let params = [];
    if (query) {
      params.push(`query=${encodeURIComponent(query)}`);
    }
    if (status) {
      params.push(`status=${encodeURIComponent(status)}`);
    }
    
    // Join parameters if they exist and append to the URL
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }


    let response = await https().get(url);


    store.dispatch(setAllBillinginvoicesConsumers(response?.data));

    if (response?.status === 200) {
      store.dispatch(setAllBillinginvoicesConsumers(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// EDIT BILLING CONSUMER

const editConsumer = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().put(`/billingconsumer/${data?.id}`, data);

    if (response?.status === 200) {
      getAllBillingConsumers(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE BILLING CONSUMER

const removeBillingConsumer = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));

    // console.log('data',data);

    let response = await https().delete(`/billingconsumer/${data?.id}`);

    if (response?.status === 200) {
      await getAllBillingConsumers((showLoading = true));
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

//get BILLING RECURRING INVOICES

const getAllBillingRecurringInvoices = async (payload, showLoading = true) => {
  try {
    const { query, page } = payload;
    if (showLoading) store.dispatch(setLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/get-recurring-invoices/${page ? page : 'all'}${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );

    store.dispatch(setAllBillingRecurringinvoices(response?.data));
    if (response?.status === 200) {
      store.dispatch(setAllBillingRecurringinvoices(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getAllBillingPaidInvoices = async (payload, showLoading = true) => {
  try {
    const { query, page } = payload;
    if (showLoading) store.dispatch(setLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/get-paidinvoices/${page ? page : 'all'}${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );

    store.dispatch(setAllBillingPaidinvoices(response?.data));
    if (response?.status === 200) {
      store.dispatch(setAllBillingPaidinvoices(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// get single billing invoice

const getSingleBillingInvoices = async (payload, showLoading = true) => {
  try {
    const {query} = payload;
    if (showLoading) store.dispatch(setLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/get-single-invoices${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );


    if (response?.status === 200) {
    return response
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// get single billing invoice skypoint

const getSingleBillingInvoicesSkypoint = async (payload, showLoading = true) => {
  try {
    const {query} = payload;
    if (showLoading) store.dispatch(setLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/skypoint/get-single-invoices${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );

    if (response?.status === 200) {
    return response
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};




// get Report of Invoices

const createBillingReportInvoices = async (data, callback) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/report", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// get cash and cheques invoices


const getAllCashAndChequeInvoice = async (payload, showLoading = true) => {
  try {

   


    

    let response = await https().get("billingInvoices/cash-cheque");


     store.dispatch(setAllCashChequeInvoices(response?.data));

    return response

  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// PAUSED RECURRING INVOICE
const PausedRecurringInvoice = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/pause-recurring-invoice", data);
    if (response?.status === 200) {
          let payload = {
      page: 1,
    };
      getAllBillingRecurringInvoices(payload);
    }
    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};



export {
  createBillingInvoices,
  getAllBillingConsumers,
  getAllBillingInvoices,
  resendInvoiceEmail,
  createBillingconsumer,
  getAllBillingRecurringInvoices,
  getAllBillingPaidInvoices,
  editConsumer,
  EditBillingInvoice,
  removeBillingInvoice,
  removeBillingConsumer,
  createBillingReportInvoices,
  UpdateBillingInvoicesStatus,
  getSingleBillingInvoices,
  getAllCashAndChequeInvoice,
  PausedRecurringInvoice,
  getSingleBillingInvoicesSkypoint,
  // editBillingclient
};
